<template lang="pug">
.coupon-exchange-container
  .top-bkg
    .safe-area(v-if="isEasyBikeApp")
    .back(v-if="isBroswer" @click="back")
    .desc
      .title 哈啰卡券兑换
  .content(v-if="hasLogin")
    input(placeholder='请输入兑换码', v-model='code')
    .btn(@click='exchange')
      .btn-name 立即兑换
  .flex-mid(v-else)
    login(
      :env="env"
      placeholder="请输入手机号"
      @login="login"
    )
</template>

<script>
import { Native, env } from '@hb/NBridge/lib/h5';
import config from '@/const/config';
import Toast from '@/components/toast';
import { LoginV2 } from '@hb/h5-components';
import { exchangeCoupon } from '@/api/activity';
import { getTokenAndKey, getTokenAndLocation } from '../../utils';

export default {
  components: {
    Login: LoginV2,
  },
  data() {
    return {
      code: '',
      exchanging: false,
      env: config.env === 'dev' ? 'fat' : config.env,
      hasLogin: false,
      userToken: '',
    };
  },
  computed: {
    isEasyBikeApp() {
      if (env.isEasyBikeApp) {
        return true;
      }
      return false;
    },
    isBroswer() {
      if (env.isAliMP || env.isEasyBikeApp) {
        return true;
      }
      return false;
    },
  },
  async created() {
    await this.checkLogin();
  },
  methods: {
    async checkLogin() {
      const { token } = await getTokenAndKey({ needLogin: false });
      if (token) {
        this.hasLogin = true;
      }
    },
    back() {
      if (env.isEasyBikeApp) {
        Native.goBack();
      } else {
        this.$router.go(-1);
      }
    },
    login(v) {
      if (v.token) {
        this.userToken = v.token;
        this.hasLogin = true;
      }
    },
    async exchange() {
      if (!this.code || this.exchanging) {
        Toast.show('兑换失败，请输入正确的兑换码');
        return;
      }
      const info = await getTokenAndLocation({ needLogin: false });
      const { cityCode, adCode } = info;
      let { token } = info;
      if (!token) {
        token = this.userToken;
      }
      this.exchanging = true;
      exchangeCoupon({
        code: this.code, token, cityCode, adCode,
      }).then((res) => {
        if (!res || !res.data) {
          Toast.show('兑换失败，请输入正确的兑换码');
          return;
        }
        const { exchangeResult } = res.data;
        if (exchangeResult === 0) {
          Toast.show('兑换失败，请输入正确的兑换码');
          return;
        }
        Toast.show('兑换成功');
        this.code = '';
      }).catch((e) => Toast.showError(e)).then(() => { this.exchanging = false; });
    },
  },
};
</script>

  <style lang="less">
  .coupon-exchange-container {
    width: 100%;
    height: 100%;
    background-color: #fff;

    .top-bkg {
      background: url(https://m.hellobike.com/resource/helloyun/12399/tubHRlV3UU.png) no-repeat top;
      background-size: 100% 100%;
      height: 2.74rem;
      width: 100vw;

      .safe-area {
        padding-top: constant(safe-area-inset-top);
        padding-top: env(safe-area-inset-top);
        height: 0.44rem;
      }

      .back {
        position: absolute;
        left: 0.12rem;
        top: 0.54rem;
        width: 0.24rem;
        height: 0.24rem;
        background: url("https://m.hellobike.com/resource/helloyun/12399/rFXTwP2cFU.png") no-repeat top;
        background-size: 100% 100%;
      }

      .desc {
        position: absolute;
        left: 0.28rem;
        top: 1.2rem;

        .title {
          height: 0.4rem;
          font-size: 0.28rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #242729;
          line-height: 0.4rem;
          margin-bottom: 0.04rem;
        }

        .subtitle {
          height: 0.2rem;
          font-size: 0.14rem;
          font-family: PingFangSC-Regular, PingFang SC, sans-serif;
          font-weight: 400;
          color: #242729;
          line-height: 0.2rem;
        }
      }
    }

    .content {
      display: flex;
      align-items: center;
      flex-direction: column;

      input {
        margin-bottom: 0.2rem;
        border: 1px solid #eee;
        width: 3.19rem;
        height: 0.54rem;
        font-size: 0.18rem;
        outline: none;
        border-radius: 0.08rem;
        padding: 0.02rem 0.1rem;
        -webkit-appearance: none;
        background-color: rgba(240, 243, 245, 0.54);
        text-align: center;
      }

      input::-webkit-input-placeholder {
        font-size: 0.16rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: #bcc4cc;
        line-height: 0.22rem;
        // text-align: center;
      }

      .btn {
        background: #0b82f1;
        width: 3.19rem;
        height: 0.52rem;
        border-radius: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-name {
          height: 0.25rem;
          font-size: 0.18rem;
          font-family: PingFangSC-Medium, PingFang SC, sans-serif;
          font-weight: 500;
          color: #fff;
          line-height: 0.25rem;
        }
      }
    }
  }
  </style>
